import clsx from "clsx";
import React from "react";
import styles from "./IndexPage.module.scss";
import { FTFlex } from "@/components/flex";
import { IconStar } from "@/assets/icons";
import { useTranslation } from "react-i18next";
import { withPublicPath } from "@/utils";
import CommonUploadSection from "@/components/common-upload-section";
import useEffectStore from "@/stores/effectStore";

export default function IndexPage() {
  const { t } = useTranslation();
  const [imageLoaded, setImageLoaded] = React.useState(false);
  const selectImage = useEffectStore((state) => state.selectImage);

  const handleSelectImage = () => {
    selectImage("upload_image");
  };
  const hanleDropItem = (file: File) => {
    selectImage("drop_image", file);
  };

  return (
    <FTFlex
      className={styles.recommend_wrap}
      gap={48}
      direction="column"
      align="center"
      justify="center"
    >
      <FTFlex
        className={styles.recommend_img}
        gap={24}
        direction="column"
        align="center"
        justify="center"
      >
        <div className={styles.img_wrapper}>
          <img
            src={withPublicPath("images/index/index.png")}
            alt=""
            onLoad={() => setImageLoaded(true)}
            className={clsx(!imageLoaded && "skeleton_loading")}
          />
        </div>

        <h2>
          <i className={styles.star}>
            <IconStar />
          </i>

          <span>{t("right_single_title")}</span>

          <i className={styles.star}>
            <IconStar />
          </i>
        </h2>
      </FTFlex>
      <FTFlex
        className={styles.recommend_upload}
        gap={16}
        direction="column"
        align="flex-start"
        justify="center"
      >
        <CommonUploadSection
          onChoose={hanleDropItem}
          onClick={handleSelectImage}
        />
      </FTFlex>
    </FTFlex>
  );
}
